import ServiceResponseSuccess from "./ServiceResponseSuccess";
import ServiceResponseFailure from "./ServiceResponseFailure";

class ServiceResponse<T = any> {
  isSuccess: boolean;
  success?: ServiceResponseSuccess<T>;
  failure?: ServiceResponseFailure;

  private constructor(success?: ServiceResponseSuccess<T>, failure?: ServiceResponseFailure) {
    this.success = success;
    this.failure = failure;
    this.isSuccess = !!success;
  }

  static Succeeded<T = any>(data: T): ServiceResponse<T> {
    const success: ServiceResponseSuccess<T> = new ServiceResponseSuccess<T>(data);
    return new ServiceResponse<T>(success, undefined);
  }
  
  static Failed<T = any>(code: number, message: string): ServiceResponse<T> {
    const failure: ServiceResponseFailure = new ServiceResponseFailure(code, message);
    return new ServiceResponse<T>(undefined, failure);
  }

  static Pending<T = any>(): ServiceResponse<T> {
    return new ServiceResponse<T>(undefined, undefined);
  }
  
}

export default ServiceResponse;